import { MetadataMomentEntrypoint } from '../../gql/graphql';
import { QueryParamKeys } from '../../constants/query-params';

export const getQueryParam = (key: QueryParamKeys): string | null => new URLSearchParams(document.location.search.substring(1)).get(key);

export const getPublicDealerIdFromParams = (): string | null => getQueryParam(QueryParamKeys.DealerPublicId) || getQueryParam(QueryParamKeys.Pdi);

// Validate that the raw URL/context value is a known MetadataMomentEntrypoint before we pass it on
export const parseEntrypoint = (param: string | null | undefined): MetadataMomentEntrypoint | null => {
  if (param && Object.values(MetadataMomentEntrypoint).includes(param as MetadataMomentEntrypoint)) {
    return param as MetadataMomentEntrypoint;
  }
  return null;
};
